import { CustomConfirmationModal } from '@modals/common/confirmations/CustomConfirmationModal';
import { useAPI } from '@providers/useAPI';
import { useMutation } from '@tanstack/react-query';
import { OrganizationsService } from 'app/API';
import { EErrorMessages } from 'app/types/errorMessages';
import toast from 'react-hot-toast';

type TProps = {
  invitationId: string;
  organizationId: string;
  onCancel: () => void;
  onSuccess: () => void;
};

export const DeleteInvitationModal = ({ invitationId, organizationId, onCancel, onSuccess }: TProps) => {
  const { call } = useAPI();

  const deleteInvitationMutation = useMutation({
    mutationFn: () =>
      call(() => OrganizationsService.deleteWsInvitation({ oid: organizationId, iid: invitationId }), {
        onError: (message: string) => {
          toast.error(message || EErrorMessages.DEFAULT);
        },
      }),
    onSuccess,
  });

  return (
    <CustomConfirmationModal
      title="Confirm"
      description="Are you sure you want to delete invitation?"
      buttonText="Delete"
      isSubmitting={deleteInvitationMutation.isPending}
      onCancel={onCancel}
      onSuccess={() => deleteInvitationMutation.mutate()}
    />
  );
};
